"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataRetrievalCard = DataRetrievalCard;
exports.EidInsightsCard = EidInsightsCard;
exports.ErrorCard = ErrorCard;
exports.GenericResultCard = GenericResultCard;
exports.IncidentAnalysisCard = IncidentAnalysisCard;
var _react = _interopRequireWildcard(require("react"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _remarkGfm = _interopRequireDefault(require("remark-gfm"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function Section(_ref) {
  let {
    title,
    icon,
    children,
    defaultOpen = true
  } = _ref;
  const [open, setOpen] = (0, _react.useState)(defaultOpen);
  return (0, _jsxRuntime.jsxs)("div", {
    className: "tw-mb-2",
    children: [(0, _jsxRuntime.jsxs)("button", {
      className: "tw-flex tw-items-center tw-gap-1.5 tw-w-full tw-text-left tw-bg-transparent tw-border-none tw-cursor-pointer tw-px-0 tw-py-1 tw-text-[13px] tw-font-semibold tw-text-sa-text hover:tw-text-sa-primary tw-transition-colors",
      onClick: () => setOpen(o => !o),
      "aria-expanded": open,
      children: [(0, _jsxRuntime.jsx)("span", {
        className: "tw-text-base",
        children: open ? '▾' : '▸'
      }), icon && (0, _jsxRuntime.jsx)("span", {
        children: icon
      }), (0, _jsxRuntime.jsx)("span", {
        children: title
      })]
    }), open && (0, _jsxRuntime.jsx)("div", {
      className: "tw-pl-5 tw-text-[13px] tw-leading-relaxed",
      children: children
    })]
  });
}
function KeyValue(_ref2) {
  let {
    label,
    value,
    highlight
  } = _ref2;
  if (value === null || value === undefined || value === '') return null;
  return (0, _jsxRuntime.jsxs)("div", {
    className: "tw-flex tw-gap-2 tw-py-0.5",
    children: [(0, _jsxRuntime.jsxs)("span", {
      className: "tw-text-sa-text-sec tw-font-medium tw-min-w-[100px] tw-flex-shrink-0",
      children: [label, ":"]
    }), (0, _jsxRuntime.jsx)("span", {
      className: highlight ? 'tw-text-sa-primary tw-font-semibold' : 'tw-text-sa-text',
      children: String(value)
    })]
  });
}
function Badge(_ref3) {
  let {
    color,
    children
  } = _ref3;
  return (0, _jsxRuntime.jsx)("span", {
    className: "tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[11px] tw-font-semibold",
    style: {
      background: "color-mix(in srgb, ".concat(color, " 15%, transparent)"),
      color
    },
    children: children
  });
}
function ErrorCard(_ref4) {
  let {
    data
  } = _ref4;
  const errorText = typeof data.error === 'string' ? data.error : 'Something went wrong.';
  return (0, _jsxRuntime.jsxs)("div", {
    className: "tw-bg-red-50 tw-border tw-border-sa-error tw-rounded-bubble-sm tw-p-3 tw-mt-1.5",
    children: [(0, _jsxRuntime.jsxs)("div", {
      className: "tw-flex tw-items-center tw-gap-2 tw-mb-1.5",
      children: [(0, _jsxRuntime.jsx)("span", {
        className: "tw-text-lg",
        children: "\u26A0\uFE0F"
      }), (0, _jsxRuntime.jsx)("strong", {
        className: "tw-text-sa-error tw-text-[13px]",
        children: "Error"
      })]
    }), (0, _jsxRuntime.jsx)("p", {
      className: "tw-text-[13px] tw-text-sa-text tw-m-0",
      children: errorText
    })]
  });
}
function IncidentAnalysisCard(_ref5) {
  var _msg$data_correction, _msg$entity_summary;
  let {
    data
  } = _ref5;
  const msg = data === null || data === void 0 ? void 0 : data.message;
  if (!msg) return (0, _jsxRuntime.jsx)(GenericResultCard, {
    data: data
  });
  const result = (msg === null || msg === void 0 ? void 0 : msg.result) || (msg === null || msg === void 0 || (_msg$data_correction = msg.data_correction) === null || _msg$data_correction === void 0 ? void 0 : _msg$data_correction.result) || (msg === null || msg === void 0 || (_msg$entity_summary = msg.entity_summary) === null || _msg$entity_summary === void 0 ? void 0 : _msg$entity_summary.result);
  if (msg !== null && msg !== void 0 && msg.analysis) {
    return (0, _jsxRuntime.jsx)("div", {
      className: "tw-bg-sa-surface tw-border tw-border-sa-border tw-rounded-bubble-sm tw-p-3 tw-mt-1.5",
      children: (0, _jsxRuntime.jsx)(Section, {
        title: "Discrepancy Analysis",
        icon: "\uD83D\uDCCA",
        defaultOpen: true,
        children: (0, _jsxRuntime.jsx)("div", {
          className: "tw-overflow-x-auto tw-text-[12px] [&_table]:tw-w-full [&_table]:tw-border-collapse [&_th]:tw-bg-sa-surface-alt [&_th]:tw-text-left [&_th]:tw-p-2 [&_th]:tw-border-b [&_th]:tw-border-sa-border [&_th]:tw-text-sa-text-sec [&_th]:tw-font-semibold [&_td]:tw-p-2 [&_td]:tw-border-b [&_td]:tw-border-sa-border-lt [&_td]:tw-text-sa-text",
          dangerouslySetInnerHTML: {
            __html: msg.analysis
          }
        })
      })
    });
  }
  if (typeof result === 'string') {
    const sections = parseIncidentSections(result);
    if (sections) {
      return (0, _jsxRuntime.jsxs)("div", {
        className: "tw-bg-sa-surface tw-border tw-border-sa-border tw-rounded-bubble-sm tw-p-3 tw-mt-1.5",
        children: [sections.summary && (0, _jsxRuntime.jsx)(Section, {
          title: "Summary",
          icon: "\uD83D\uDCCB",
          defaultOpen: true,
          children: (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
            remarkPlugins: [_remarkGfm.default],
            children: sections.summary
          })
        }), sections.rootCauses && (0, _jsxRuntime.jsx)(Section, {
          title: "Root Causes",
          icon: "\uD83D\uDD0D",
          defaultOpen: true,
          children: (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
            remarkPlugins: [_remarkGfm.default],
            children: sections.rootCauses
          })
        }), sections.recommendations && (0, _jsxRuntime.jsx)(Section, {
          title: "Recommendations",
          icon: "\uD83D\uDCA1",
          defaultOpen: true,
          children: (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
            remarkPlugins: [_remarkGfm.default],
            children: sections.recommendations
          })
        }), sections.rest && (0, _jsxRuntime.jsx)(Section, {
          title: "Details",
          icon: "\uD83D\uDCDD",
          defaultOpen: false,
          children: (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
            remarkPlugins: [_remarkGfm.default],
            children: sections.rest
          })
        })]
      });
    }
    return (0, _jsxRuntime.jsx)("div", {
      className: "tw-bg-sa-surface tw-border tw-border-sa-border tw-rounded-bubble-sm tw-p-3 tw-mt-1.5 tw-text-[13px]",
      children: (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
        remarkPlugins: [_remarkGfm.default],
        children: result
      })
    });
  }
  return (0, _jsxRuntime.jsx)(GenericResultCard, {
    data: data
  });
}
function parseIncidentSections(text) {
  const headingRegex = /(?:^|\n)#{1,3}\s*(summary|root\s*cause|recommendation|next\s*step|action|finding|risk)/i;
  if (!headingRegex.test(text)) return null;
  const splitRegex = /(?=\n#{1,3}\s)/;
  const parts = text.split(splitRegex);
  const result = {
    summary: '',
    rootCauses: '',
    recommendations: '',
    rest: ''
  };
  for (const part of parts) {
    const lower = part.toLowerCase();
    if (/summary|overview/i.test(lower.split('\n')[0])) {
      result.summary += part;
    } else if (/root\s*cause|finding|diagnosis/i.test(lower.split('\n')[0])) {
      result.rootCauses += part;
    } else if (/recommend|next\s*step|action|risk|remediat/i.test(lower.split('\n')[0])) {
      result.recommendations += part;
    } else {
      result.rest += part;
    }
  }
  return result;
}
function DataRetrievalCard(_ref6) {
  let {
    data,
    requestText
  } = _ref6;
  const msg = data === null || data === void 0 ? void 0 : data.message;
  if (!msg) return (0, _jsxRuntime.jsx)(GenericResultCard, {
    data: data
  });
  const recordKeys = ['cdcRecords', 'dynamoDbRecords', 'userServiceRecord', 'graphqlRecord'];
  const hasRecords = recordKeys.some(k => msg[k] && (Array.isArray(msg[k]) ? msg[k].length > 0 : true));
  if (!hasRecords && !msg.analysis) {
    return (0, _jsxRuntime.jsx)("div", {
      className: "tw-bg-sa-surface tw-border tw-border-sa-border tw-rounded-bubble-sm tw-p-3 tw-mt-1.5 tw-text-[13px] tw-text-sa-text-sec",
      children: "No records found."
    });
  }
  return (0, _jsxRuntime.jsxs)("div", {
    className: "tw-bg-sa-surface tw-border tw-border-sa-border tw-rounded-bubble-sm tw-p-3 tw-mt-1.5",
    children: [(0, _jsxRuntime.jsx)("p", {
      className: "tw-text-[13px] tw-text-sa-text tw-mb-2",
      children: "\uD83D\uDCE6 The data you requested is below. Click a record to expand and view details."
    }), msg.cdcRecords && msg.cdcRecords.length > 0 && (0, _jsxRuntime.jsx)(Section, {
      title: "CDC Records (".concat(msg.cdcRecords.length, ")"),
      icon: "\uD83C\uDFE5",
      children: msg.cdcRecords.map((rec, i) => (0, _jsxRuntime.jsx)(CollapsibleRecordV2, {
        raw: rec
      }, i))
    }), msg.dynamoDbRecords && msg.dynamoDbRecords.length > 0 && (0, _jsxRuntime.jsx)(Section, {
      title: "DynamoDB Records (".concat(msg.dynamoDbRecords.length, ")"),
      icon: "\u26A1",
      children: msg.dynamoDbRecords.map((rec, i) => (0, _jsxRuntime.jsx)(CollapsibleRecordV2, {
        raw: rec
      }, i))
    }), msg.graphqlRecord && (0, _jsxRuntime.jsx)(Section, {
      title: "GraphQL Record",
      icon: "\uD83D\uDD17",
      children: (0, _jsxRuntime.jsx)(CollapsibleRecordV2, {
        raw: msg.graphqlRecord
      })
    }), msg.userServiceRecord && (0, _jsxRuntime.jsx)(Section, {
      title: "User Service Record",
      icon: "\uD83D\uDC64",
      children: (0, _jsxRuntime.jsx)(CollapsibleRecordV2, {
        raw: msg.userServiceRecord
      })
    }), msg.analysis && (0, _jsxRuntime.jsx)(Section, {
      title: "Discrepancy Analysis",
      icon: "\uD83D\uDCCA",
      children: (0, _jsxRuntime.jsx)("div", {
        className: "tw-overflow-x-auto tw-text-[12px] [&_table]:tw-w-full [&_table]:tw-border-collapse [&_th]:tw-bg-sa-surface-alt [&_th]:tw-text-left [&_th]:tw-p-2 [&_th]:tw-border-b [&_th]:tw-border-sa-border [&_th]:tw-text-sa-text-sec [&_th]:tw-font-semibold [&_td]:tw-p-2 [&_td]:tw-border-b [&_td]:tw-border-sa-border-lt [&_td]:tw-text-sa-text",
        dangerouslySetInnerHTML: {
          __html: msg.analysis
        }
      })
    }), requestText && (0, _jsxRuntime.jsxs)("p", {
      className: "tw-text-[11px] tw-text-sa-text-muted tw-mt-2 tw-italic",
      children: ["Request: ", requestText]
    })]
  });
}
function CollapsibleRecordV2(_ref7) {
  var _demographics, _demographics$name$0$, _demographics2, _demographics3, _demographics4, _demographics5, _demographics6, _demographics7;
  let {
    raw
  } = _ref7;
  const [expanded, setExpanded] = (0, _react.useState)(false);
  let parsed = null;
  let recordId = '';
  let recordType = '';
  let demographics = null;
  try {
    parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    recordId = parsed.recordId || 'Unknown';
    recordType = parsed.recordType || '';
    demographics = parsed.demographics ? typeof parsed.demographics === 'string' ? JSON.parse(parsed.demographics) : parsed.demographics : null;
  } catch (_unused) {
    return (0, _jsxRuntime.jsx)("div", {
      className: "tw-bg-gray-50 tw-rounded-md tw-p-2 tw-mb-2 tw-text-[12px] tw-text-sa-text-sec",
      children: "Unable to parse record data."
    });
  }
  const name = (_demographics = demographics) !== null && _demographics !== void 0 && (_demographics = _demographics.name) !== null && _demographics !== void 0 && _demographics[0] ? "".concat(((_demographics$name$0$ = demographics.name[0].given) === null || _demographics$name$0$ === void 0 ? void 0 : _demographics$name$0$.join(' ')) || '', " ").concat(demographics.name[0].family || '').trim() : (_demographics2 = demographics) !== null && _demographics2 !== void 0 && (_demographics2 = _demographics2.personNames) !== null && _demographics2 !== void 0 && _demographics2[0] ? "".concat(demographics.personNames[0].firstName || '', " ").concat(demographics.personNames[0].lastName || '').trim() : (_demographics3 = demographics) !== null && _demographics3 !== void 0 && _demographics3.givenName ? "".concat(demographics.givenName, " ").concat(demographics.familyName || '').trim() : '';
  const dob = ((_demographics4 = demographics) === null || _demographics4 === void 0 ? void 0 : _demographics4.birthDate) || ((_demographics5 = demographics) === null || _demographics5 === void 0 || (_demographics5 = _demographics5.demographicInfo) === null || _demographics5 === void 0 ? void 0 : _demographics5.birthDate) || '';
  const gender = ((_demographics6 = demographics) === null || _demographics6 === void 0 ? void 0 : _demographics6.gender) || ((_demographics7 = demographics) === null || _demographics7 === void 0 || (_demographics7 = _demographics7.demographicInfo) === null || _demographics7 === void 0 || (_demographics7 = _demographics7.genderType) === null || _demographics7 === void 0 ? void 0 : _demographics7.code) || '';
  return (0, _jsxRuntime.jsxs)("div", {
    className: "tw-mb-2 tw-border tw-border-sa-border-lt tw-rounded-md tw-overflow-hidden",
    children: [(0, _jsxRuntime.jsxs)("button", {
      className: "tw-flex tw-items-center tw-justify-between tw-w-full tw-text-left tw-bg-sa-surface-alt tw-px-3 tw-py-2 tw-border-none tw-cursor-pointer tw-text-[13px] tw-font-sa hover:tw-bg-sa-primary-lt/30 tw-transition-colors",
      onClick: () => setExpanded(e => !e),
      "aria-expanded": expanded,
      children: [(0, _jsxRuntime.jsxs)("div", {
        className: "tw-flex tw-items-center tw-gap-2 tw-min-w-0 tw-flex-1",
        children: [recordType && (0, _jsxRuntime.jsx)(Badge, {
          color: "#8b5cf6",
          children: recordType
        }), (0, _jsxRuntime.jsx)("span", {
          className: "tw-font-semibold tw-text-sa-text tw-truncate",
          children: recordId
        })]
      }), (0, _jsxRuntime.jsx)("span", {
        className: "tw-text-sa-text-muted tw-ml-2 tw-flex-shrink-0",
        children: expanded ? '−' : '+'
      })]
    }), (name || dob || gender) && (0, _jsxRuntime.jsxs)("div", {
      className: "tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-0.5 tw-px-3 tw-py-1.5 tw-text-[12px] tw-text-sa-text-sec tw-bg-sa-surface",
      children: [name && (0, _jsxRuntime.jsxs)("span", {
        children: ["\uD83D\uDC64 ", name]
      }), dob && (0, _jsxRuntime.jsxs)("span", {
        children: ["\uD83C\uDF82 ", dob]
      }), gender && (0, _jsxRuntime.jsxs)("span", {
        children: ["\u26A7 ", gender]
      })]
    }), expanded && demographics && (0, _jsxRuntime.jsx)("div", {
      className: "tw-px-3 tw-py-2 tw-bg-sa-surface tw-border-t tw-border-sa-border-lt tw-max-h-[400px] tw-overflow-auto",
      children: (0, _jsxRuntime.jsx)(DemographicsView, {
        data: demographics
      })
    })]
  });
}
function DemographicsView(_ref8) {
  let {
    data
  } = _ref8;
  if (data.resourceType === 'Patient') {
    const names = data.name || [];
    const addresses = data.address || [];
    const telecoms = data.telecom || [];
    const identifiers = data.identifier || [];
    return (0, _jsxRuntime.jsxs)("div", {
      className: "tw-text-[12px]",
      children: [names.length > 0 && (0, _jsxRuntime.jsx)(Section, {
        title: "Names",
        icon: "\uD83D\uDCDB",
        defaultOpen: true,
        children: names.map((n, i) => {
          var _n$given;
          return (0, _jsxRuntime.jsxs)("div", {
            className: "tw-py-0.5",
            children: [(0, _jsxRuntime.jsx)(KeyValue, {
              label: "Use",
              value: n.use
            }), (0, _jsxRuntime.jsx)(KeyValue, {
              label: "Name",
              value: "".concat(((_n$given = n.given) === null || _n$given === void 0 ? void 0 : _n$given.join(' ')) || '', " ").concat(n.family || '').trim(),
              highlight: true
            })]
          }, i);
        })
      }), (0, _jsxRuntime.jsx)(KeyValue, {
        label: "Gender",
        value: data.gender
      }), (0, _jsxRuntime.jsx)(KeyValue, {
        label: "Birth Date",
        value: data.birthDate,
        highlight: true
      }), addresses.length > 0 && (0, _jsxRuntime.jsx)(Section, {
        title: "Addresses",
        icon: "\uD83D\uDCCD",
        defaultOpen: false,
        children: addresses.map((a, i) => (0, _jsxRuntime.jsx)("div", {
          className: "tw-py-0.5",
          children: (0, _jsxRuntime.jsx)("span", {
            className: "tw-text-sa-text",
            children: [...(a.line || []), a.city, a.state, a.postalCode, a.country].filter(Boolean).join(', ')
          })
        }, i))
      }), telecoms.length > 0 && (0, _jsxRuntime.jsx)(Section, {
        title: "Contact",
        icon: "\uD83D\uDCDE",
        defaultOpen: false,
        children: telecoms.map((t, i) => (0, _jsxRuntime.jsx)(KeyValue, {
          label: t.system || 'Contact',
          value: t.value
        }, i))
      }), identifiers.length > 0 && (0, _jsxRuntime.jsxs)(Section, {
        title: "Identifiers (".concat(identifiers.length, ")"),
        icon: "\uD83D\uDD11",
        defaultOpen: false,
        children: [identifiers.slice(0, 10).map((id, i) => {
          var _id$type;
          return (0, _jsxRuntime.jsx)(KeyValue, {
            label: id.system || ((_id$type = id.type) === null || _id$type === void 0 || (_id$type = _id$type.coding) === null || _id$type === void 0 || (_id$type = _id$type[0]) === null || _id$type === void 0 ? void 0 : _id$type.code) || 'ID',
            value: id.value
          }, i);
        }), identifiers.length > 10 && (0, _jsxRuntime.jsxs)("p", {
          className: "tw-text-sa-text-muted tw-text-[11px]",
          children: ["+", identifiers.length - 10, " more\u2026"]
        })]
      })]
    });
  }
  if (data.masterIndividualIdentifier || data.demographicInfo) {
    var _demo$genderType;
    const demo = data.demographicInfo || {};
    const names = data.personNames || [];
    const addresses = data.postalAddresses || [];
    const emails = data.electronicAddresses || [];
    return (0, _jsxRuntime.jsxs)("div", {
      className: "tw-text-[12px]",
      children: [(0, _jsxRuntime.jsx)(KeyValue, {
        label: "Master ID",
        value: data.masterIndividualIdentifier,
        highlight: true
      }), names.length > 0 && names.map((n, i) => (0, _jsxRuntime.jsx)(KeyValue, {
        label: "Name",
        value: "".concat(n.firstName || '', " ").concat(n.lastName || '').trim(),
        highlight: true
      }, i)), (0, _jsxRuntime.jsx)(KeyValue, {
        label: "Gender",
        value: (_demo$genderType = demo.genderType) === null || _demo$genderType === void 0 ? void 0 : _demo$genderType.code
      }), (0, _jsxRuntime.jsx)(KeyValue, {
        label: "Birth Date",
        value: demo.birthDate
      }), emails.length > 0 && (0, _jsxRuntime.jsx)(Section, {
        title: "Emails",
        icon: "\uD83D\uDCE7",
        defaultOpen: false,
        children: emails.map((e, i) => {
          var _e$communicationType;
          return (0, _jsxRuntime.jsx)(KeyValue, {
            label: ((_e$communicationType = e.communicationType) === null || _e$communicationType === void 0 ? void 0 : _e$communicationType.description) || 'Email',
            value: e.electronicAddress
          }, i);
        })
      })]
    });
  }
  if (data.givenName || data.familyName) {
    var _data$contacts, _data$contacts2, _data$aliases;
    return (0, _jsxRuntime.jsxs)("div", {
      className: "tw-text-[12px]",
      children: [(0, _jsxRuntime.jsx)(KeyValue, {
        label: "Name",
        value: "".concat(data.givenName || '', " ").concat(data.familyName || '').trim(),
        highlight: true
      }), (0, _jsxRuntime.jsx)(KeyValue, {
        label: "Gender",
        value: data.gender
      }), (0, _jsxRuntime.jsx)(KeyValue, {
        label: "Birth Date",
        value: data.birthDate
      }), ((_data$contacts = data.contacts) === null || _data$contacts === void 0 || (_data$contacts = _data$contacts.postalAddresses) === null || _data$contacts === void 0 ? void 0 : _data$contacts.length) > 0 && (0, _jsxRuntime.jsx)(Section, {
        title: "Addresses",
        icon: "\uD83D\uDCCD",
        defaultOpen: false,
        children: data.contacts.postalAddresses.map((a, i) => (0, _jsxRuntime.jsx)("div", {
          className: "tw-py-0.5",
          children: (0, _jsxRuntime.jsx)("span", {
            className: "tw-text-sa-text",
            children: [a.addressLineOne, a.addressLineTwo, a.city, a.provinceState, a.zipPostalCode, a.country].filter(Boolean).join(', ')
          })
        }, i))
      }), ((_data$contacts2 = data.contacts) === null || _data$contacts2 === void 0 || (_data$contacts2 = _data$contacts2.telephoneNumbers) === null || _data$contacts2 === void 0 ? void 0 : _data$contacts2.length) > 0 && (0, _jsxRuntime.jsx)(Section, {
        title: "Phone Numbers",
        icon: "\uD83D\uDCDE",
        defaultOpen: false,
        children: data.contacts.telephoneNumbers.map((t, i) => (0, _jsxRuntime.jsx)(KeyValue, {
          label: t.type || 'Phone',
          value: t.number
        }, i))
      }), ((_data$aliases = data.aliases) === null || _data$aliases === void 0 ? void 0 : _data$aliases.length) > 0 && (0, _jsxRuntime.jsx)(Section, {
        title: "Aliases",
        icon: "\uD83D\uDD04",
        defaultOpen: false,
        children: data.aliases.map((a, i) => (0, _jsxRuntime.jsx)(KeyValue, {
          label: "Alias",
          value: "".concat(a.firstName || '', " ").concat(a.lastName || '').trim()
        }, i))
      })]
    });
  }
  return (0, _jsxRuntime.jsx)("pre", {
    className: "tw-whitespace-pre-wrap tw-break-words tw-text-[11px] tw-text-sa-text tw-m-0",
    children: JSON.stringify(data, null, 2)
  });
}
function EidInsightsCard(_ref9) {
  var _msg$entity_summary2;
  let {
    data
  } = _ref9;
  const msg = data === null || data === void 0 ? void 0 : data.message;
  if (!msg) return (0, _jsxRuntime.jsx)(GenericResultCard, {
    data: data
  });
  const result = (msg === null || msg === void 0 || (_msg$entity_summary2 = msg.entity_summary) === null || _msg$entity_summary2 === void 0 ? void 0 : _msg$entity_summary2.result) || (msg === null || msg === void 0 ? void 0 : msg.result);
  if (typeof result === 'string') {
    const sections = parseEidSections(result);
    return (0, _jsxRuntime.jsxs)("div", {
      className: "tw-bg-sa-surface tw-border tw-border-sa-border tw-rounded-bubble-sm tw-p-3 tw-mt-1.5",
      children: [(0, _jsxRuntime.jsxs)("div", {
        className: "tw-flex tw-items-center tw-gap-2 tw-mb-2",
        children: [(0, _jsxRuntime.jsx)("span", {
          className: "tw-text-lg",
          children: "\uD83D\uDD0E"
        }), (0, _jsxRuntime.jsx)("strong", {
          className: "tw-text-[14px] tw-text-sa-text",
          children: "EID Insights"
        })]
      }), sections.demographics && (0, _jsxRuntime.jsx)(Section, {
        title: "Demographics",
        icon: "\uD83D\uDC64",
        defaultOpen: true,
        children: (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
          remarkPlugins: [_remarkGfm.default],
          children: sections.demographics
        })
      }), sections.anomalies && (0, _jsxRuntime.jsx)(Section, {
        title: "Anomalies & Signals",
        icon: "\u26A1",
        defaultOpen: true,
        children: (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
          remarkPlugins: [_remarkGfm.default],
          children: sections.anomalies
        })
      }), sections.duplicates && (0, _jsxRuntime.jsx)(Section, {
        title: "Duplicate Signals",
        icon: "\uD83D\uDD17",
        defaultOpen: true,
        children: (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
          remarkPlugins: [_remarkGfm.default],
          children: sections.duplicates
        })
      }), sections.recommendations && (0, _jsxRuntime.jsx)(Section, {
        title: "Recommendations",
        icon: "\uD83D\uDCA1",
        defaultOpen: true,
        children: (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
          remarkPlugins: [_remarkGfm.default],
          children: sections.recommendations
        })
      }), sections.rest && (0, _jsxRuntime.jsx)(Section, {
        title: "Additional Details",
        icon: "\uD83D\uDCDD",
        defaultOpen: false,
        children: (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
          remarkPlugins: [_remarkGfm.default],
          children: sections.rest
        })
      })]
    });
  }
  return (0, _jsxRuntime.jsx)(GenericResultCard, {
    data: data
  });
}
function parseEidSections(text) {
  const result = {
    demographics: '',
    anomalies: '',
    duplicates: '',
    recommendations: '',
    rest: ''
  };
  const splitRegex = /(?=\n#{1,3}\s)/;
  const parts = text.split(splitRegex);
  for (const part of parts) {
    const firstLine = part.split('\n')[0].toLowerCase();
    if (/demograph|identity|overview|summary/i.test(firstLine)) {
      result.demographics += part;
    } else if (/anomal|signal|risk|flag/i.test(firstLine)) {
      result.anomalies += part;
    } else if (/duplic|overmerge|match/i.test(firstLine)) {
      result.duplicates += part;
    } else if (/recommend|next|action/i.test(firstLine)) {
      result.recommendations += part;
    } else {
      result.rest += part;
    }
  }
  return result;
}
function GenericResultCard(_ref0) {
  var _msg$data_correction2, _msg$entity_summary3;
  let {
    data
  } = _ref0;
  const msg = data === null || data === void 0 ? void 0 : data.message;
  const result = (msg === null || msg === void 0 || (_msg$data_correction2 = msg.data_correction) === null || _msg$data_correction2 === void 0 ? void 0 : _msg$data_correction2.result) || (msg === null || msg === void 0 || (_msg$entity_summary3 = msg.entity_summary) === null || _msg$entity_summary3 === void 0 ? void 0 : _msg$entity_summary3.result) || (msg === null || msg === void 0 ? void 0 : msg.result) || (msg === null || msg === void 0 ? void 0 : msg.raw_text) || msg;
  const text = typeof result === 'string' ? result : JSON.stringify(result, null, 2);
  return (0, _jsxRuntime.jsx)("div", {
    className: "tw-bg-sa-surface tw-border tw-border-sa-border tw-rounded-bubble-sm tw-p-3 tw-mt-1.5 tw-text-[13px]",
    children: (0, _jsxRuntime.jsx)(_reactMarkdown.default, {
      remarkPlugins: [_remarkGfm.default],
      children: text
    })
  });
}